// Generated by purs version 0.15.15
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semigroup_Foldable from "../Data.Semigroup.Foldable/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable1 from "../Data.Unfoldable1/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Tuple.functorTuple);
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var foldMap1 = /* #__PURE__ */ Data_Semigroup_Foldable.foldMap1(Data_List_Types.foldable1NonEmptyList);
var foldr1 = /* #__PURE__ */ Data_Semigroup_Foldable.foldr1(Data_List_Types.foldable1NonEmptyList);
var foldl1 = /* #__PURE__ */ Data_Semigroup_Foldable.foldl1(Data_List_Types.foldable1NonEmptyList);
var NonEmptySet = function (x) {
    return x;
};
var unionSet = function (dictOrd) {
    return coerce(Data_Semigroup.append(Data_Set.semigroupSet(dictOrd)));
};
var toUnfoldable1 = function (dictUnfoldable1) {
    var stepNext = Data_Map_Internal.stepAscCps(function (k, v, next) {
        return new Data_Maybe.Just(new Data_Tuple.Tuple(k, next));
    })(function (v) {
        return Data_Maybe.Nothing.value;
    });
    var stepHead = Data_Map_Internal.stepAscCps(function (k, v, next) {
        return new Data_Tuple.Tuple(k, next);
    })(function (v) {
        return Partial_Unsafe.unsafeCrashWith("toUnfoldable1: impossible");
    });
    var $82 = Data_Unfoldable1.unfoldr1(dictUnfoldable1)(function (v) {
        return map1(stepNext)(v);
    });
    return function ($83) {
        return $82(stepHead(Data_Map_Internal.toMapIter(Data_Set.toMap(coerce($83)))));
    };
};
var toUnfoldable11 = /* #__PURE__ */ toUnfoldable1(Data_Array_NonEmpty_Internal.unfoldable1NonEmptyArray);
var toUnfoldable12 = /* #__PURE__ */ toUnfoldable1(Data_List_Types.unfoldable1NonEmptyList);
var toUnfoldable = function (dictUnfoldable) {
    return coerce(Data_Set.toUnfoldable(dictUnfoldable));
};
var toSet = function (v) {
    return v;
};
var subset = function (dictOrd) {
    return coerce(Data_Set.subset(dictOrd));
};
var size = /* #__PURE__ */ coerce(Data_Set.size);
var singleton = /* #__PURE__ */ coerce(Data_Set.singleton);
var showNonEmptySet = function (dictShow) {
    var show = Data_Show.show(Data_Array_NonEmpty_Internal.showNonEmptyArray(dictShow));
    return {
        show: function (s) {
            return "(fromFoldable1 " + (show(toUnfoldable11(s)) + ")");
        }
    };
};
var semigroupNonEmptySet = function (dictOrd) {
    return Data_Set.semigroupSet(dictOrd);
};
var properSubset = function (dictOrd) {
    return coerce(Data_Set.properSubset(dictOrd));
};
var ordNonEmptySet = function (dictOrd) {
    return Data_Set.ordSet(dictOrd);
};
var ord1NonEmptySet = Data_Set.ord1Set;
var min = function (v) {
    return fromJust(Data_Set.findMin(v));
};
var member = function (dictOrd) {
    return coerce(Data_Set.member(dictOrd));
};
var max = function (v) {
    return fromJust(Data_Set.findMax(v));
};
var mapMaybe = function (dictOrd) {
    return coerce(Data_Set.mapMaybe(dictOrd));
};
var map = function (dictOrd) {
    return coerce(Data_Set.map(dictOrd));
};
var insert = function (dictOrd) {
    return coerce(Data_Set.insert(dictOrd));
};
var fromSet = function (s) {
    var $75 = Data_Set.isEmpty(s);
    if ($75) {
        return Data_Maybe.Nothing.value;
    };
    return new Data_Maybe.Just(s);
};
var intersection = function (dictOrd) {
    var intersection1 = Data_Set.intersection(dictOrd);
    return function (v) {
        return function (v1) {
            return fromSet(intersection1(v)(v1));
        };
    };
};
var fromFoldable1 = function (dictFoldable1) {
    var foldMap11 = Data_Semigroup_Foldable.foldMap1(dictFoldable1);
    return function (dictOrd) {
        return foldMap11(semigroupNonEmptySet(dictOrd))(singleton);
    };
};
var fromFoldable = function (dictFoldable) {
    var fromFoldable2 = Data_Set.fromFoldable(dictFoldable);
    return function (dictOrd) {
        var $84 = fromFoldable2(dictOrd);
        return function ($85) {
            return fromSet($84($85));
        };
    };
};
var foldableNonEmptySet = Data_Set.foldableSet;
var foldable1NonEmptySet = {
    foldMap1: function (dictSemigroup) {
        var foldMap11 = foldMap1(dictSemigroup);
        return function (f) {
            var $86 = foldMap11(f);
            return function ($87) {
                return $86(toUnfoldable12($87));
            };
        };
    },
    foldr1: function (f) {
        var $88 = foldr1(f);
        return function ($89) {
            return $88(toUnfoldable12($89));
        };
    },
    foldl1: function (f) {
        var $90 = foldl1(f);
        return function ($91) {
            return $90(toUnfoldable12($91));
        };
    },
    Foldable0: function () {
        return foldableNonEmptySet;
    }
};
var filter = function (dictOrd) {
    return coerce(Data_Set.filter(dictOrd));
};
var eqNonEmptySet = function (dictEq) {
    return Data_Set.eqSet(dictEq);
};
var eq1NonEmptySet = Data_Set.eq1Set;
var difference = function (dictOrd) {
    var difference1 = Data_Set.difference(dictOrd);
    return function (v) {
        return function (v1) {
            return fromSet(difference1(v)(v1));
        };
    };
};
var $$delete = function (dictOrd) {
    var delete1 = Data_Set["delete"](dictOrd);
    return function (a) {
        return function (v) {
            return fromSet(delete1(a)(v));
        };
    };
};
var cons = function (dictOrd) {
    return coerce(Data_Set.insert(dictOrd));
};
export {
    singleton,
    cons,
    fromSet,
    fromFoldable,
    fromFoldable1,
    toSet,
    toUnfoldable,
    toUnfoldable1,
    map,
    member,
    insert,
    $$delete as delete,
    size,
    min,
    max,
    unionSet,
    difference,
    subset,
    properSubset,
    intersection,
    filter,
    mapMaybe,
    eqNonEmptySet,
    eq1NonEmptySet,
    ordNonEmptySet,
    ord1NonEmptySet,
    semigroupNonEmptySet,
    foldableNonEmptySet,
    foldable1NonEmptySet,
    showNonEmptySet
};
//# sourceMappingURL=index.js.map
